import { normalize } from 'normalizr';
import { query, mutation } from '@/dex-shared/helpers/graphql';
import { article } from '@/dex-shared/helpers/normalizr_schema';

export default {
  async PULL_ARTICLE_BY_ID({ commit }: any, articleId: number) {
    // PullArticle should deal with ltreeKnowledges
    const response = await query(
      `query PullArticle($articleId: Int!) {
        articleById(id: $articleId) {
          id
          title
          group
          
          contentsByArticleId {
            nodes {
              id
              position
              articleId
              textByTextId {
                id
                body
                alignment
                source
              }
              imageByImageId {
                id
                url
                source
                resizeFactor
                description
              }
              videoByVideoId {
                id
                providerId
                providerType
              }
            }
          }
          
          listItemsByArticleId {
            totalCount
            nodes {
              listByListId {
                id
                name
              }
            }
          }
          knowledgeAssociationsByArticleId {
            nodes {
              formative
              summative
              knowledgeByKnowledgeId {
                id
                name
              }
            }
          }
          
        }
      }`,
      {
        articleId: +articleId,
      },
    );
    let normalizedResponse = normalize(response.data.articleById, article);
    commit('SET_NORMALIZED_DATA', normalizedResponse.entities);
  },

  async PUSH_ARTICLE_BY_ID({ dispatch, getters }: any, articleId: number) {
    let article = getters.articleById(articleId);

    return Promise.all([
      dispatch('UPDATE_CONTENTS', article.contents()),
      mutation(
        `mutation PushArticle($id: Int!, $title: String, $content: JSON, $group: String) {
          updateArticleById(
            input: {
              id: $id
              articlePatch: {
                draft: false
                title: $title
                content: $content
                group: $group
              }
            }
          ) {
            article {
              id
              draft
              title
              content
              group
            }
          }
        }`,
        article.raw(),
      ),
    ]);
  },

  async CREATE_ARTICLE({ commit, rootState }) {
    let userId = rootState.auth.user.id;
    let response = await mutation(
      `mutation CreateArticle ($userId: Int!) {
        createArticle(input: {
          article: {
            userId: $userId
            draft: true
          }
        }) {
          article {
            id
          }
        }
      }`,
      {
        userId,
      },
    );
    commit('UPDATE_ENTITY', {
      entity: 'articles',
      data: response.data.createArticle.article,
    });
    return response.data.createArticle.article.id;
  },
};
